import { LogAfterTimeout } from "reports/components/Reports/LogAfterTimeout";
import styled from "styled-components/macro";
import loadingCircleGIF from "./gifs/Loading Circle white.gif";

const LoadingCircleStyles = styled.div<{
  $marginTopEm: number;
  $widthPct: number;
}>`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: white;
  img {
    margin-top: ${props => props.$marginTopEm}em;
    width: ${props => props.$widthPct}%;
    height: auto;
  }
`;

export default function LoadingCircle({
  marginTopEm = 2,
  widthPct = 25,
  logAfterTimeout,
}: {
  marginTopEm?: number;
  widthPct?: number;
  /** if provided, console.logs `logData` after `delay` milliseconds */
  logAfterTimeout?: { logData: any; delay: number };
}) {
  return (
    <>
      <LoadingCircleStyles $marginTopEm={marginTopEm} $widthPct={widthPct}>
        <img src={loadingCircleGIF} alt="Loading...." />
      </LoadingCircleStyles>
      {logAfterTimeout ? (
        <LogAfterTimeout
          logData={logAfterTimeout.logData}
          delay={logAfterTimeout.delay}
        />
      ) : null}
    </>
  );
}
